<div class="page-head">
  <div>
    <h1>Platform overview</h1>
    <div class="sub">Users, roles and businesses</div>
  </div>
</div>

<div class="page-body">
  <div class="card-grid">
    <div class="card" (click)="goTo('users')">
      <h3>Users</h3>
      <p>Manage user-role assignments.</p>
    </div>
    <div class="card" (click)="goTo('roles')">
      <h3>Roles</h3>
      <p>View and edit roles.</p>
    </div>
    <div class="card" (click)="goTo('permissions')">
      <h3>Permissions</h3>
      <p>Add and manage permissions.</p>
    </div>
    <div class="card" (click)="goTo('businesses')">
      <h3>Businesses</h3>
      <p>Browse businesses, users, roles, and permissions.</p>
    </div>
  </div>

  <section class="panel">
    <div class="panel-head">
      <div>
        <div class="panel-title" style="margin:0">Users needing attention</div>
        <div class="row-sub">A user has no system-level role, or is missing a name.</div>
      </div>
      <span class="pill pill-grey"
        [attr.aria-label]="attentionUsers.length + ' of ' + (users.length || 0) + ' users need attention'">
        {{ attentionUsers.length }} / {{ users.length || 0 }}
      </span>
    </div>

    @if (attentionUsers && attentionUsers.length > 0) {
      <ul class="rows">
        @for (u of attentionUsers; track u.userId) {
          <li class="row clickable" [routerLink]="['/users', u.userId]">
            <div class="row-main">
              <div class="row-title">{{ u.firstName }} {{ u.lastName }}</div>
              <div class="row-sub">{{ u.email }}</div>
            </div>
            <span class="alert-badge" title="User has no system roles">Needs attention</span>
          </li>
        }
      </ul>
    } @else {
      <div class="note note-ok">All users have at least one system role.</div>
    }
  </section>
</div>
